import React from 'react';
import '../../assets/css/App.css';
import Header from "../../features/Layout/Header";
import Footer from "../../features/Layout/Footer";
import { withTranslation } from 'react-i18next';

class Accessibility extends React.Component {
    render() {
        const { t } = this.props;
        return(
            <div className="App Terms">
                <Header  hide='false' hideSearch={true} />
                <main>
                    <h1>{t('pages.accessibility.title')}</h1>
                    <p dangerouslySetInnerHTML={{ __html: t('pages.accessibility.content') }} />
                </main>            
                <Footer />
            </div>
        );
    }
}

export default withTranslation()(Accessibility);